module.exports = __webpack_public_path__ + "img/genres-and-tags.22c519cb.svg";